/**
 * NotesModal — replaces $ionicModal from templates/notes_modal.html + editNotes/saveNotes in RunCtrl.
 */

import { Button, Textarea } from '@mantine/core';
import { ModalFrame } from './ModalFrame';

interface Props {
  opened: boolean;
  notes: string;
  onNotesChange: (val: string) => void;
  onSave: () => void;
  onClose: () => void;
}

export function NotesModal({ opened, notes, onNotesChange, onSave, onClose }: Props) {
  return (
    <ModalFrame
      opened={opened}
      onClose={onClose}
      title="Driver Notes"
      actions={
        <>
          <Button variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Button color="blue" onClick={onSave}>
            Save Notes
          </Button>
        </>
      }
    >
      {/* The modal's focus trap moves focus to the first control, which is the close
          button, unless a control carries data-autofocus. A plain autoFocus would lose
          the focus again. */}
      <Textarea
        label="My notes for this pickup"
        value={notes}
        onChange={e => onNotesChange(e.currentTarget.value)}
        autosize
        minRows={4}
        data-autofocus
      />
    </ModalFrame>
  );
}
